@import 'node_modules/@glidejs/glide/src/assets/sass/glide.core';

.kdx-carousel {
    position: relative;

    .st-carousel__showing {
        display: none;
        text-align: center;
        padding-bottom: 10px;
    }

    .st-carousel-inner {
        position: relative;
    }

    .glide__slides {
        white-space: normal;
    }

    .controls {
        button {
            position: absolute;
            background: $carouselArrowBG;
            top: 50%;
            transform: translateY(-50%);
			border: 1px solid transparent;
            width: 44px;
            height: 44px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 3;
            transition: background .2s ease-in-out;

            &:hover, &:focus {
                background: $carouselArrowBGHover;
				border: 1px solid $carouselArrowBGHover;

                svg { fill: $carouselArrowSvgColorHover; }
            }
            svg {
                @include svg-format(16px, 22px, $carouselArrowSvgColor);
                svg { transform: translate(-1px, -1px); }
            }
            &.left-btn {
                left: 24px;

                svg { transform: translate(-2px, -2px); }
            }
            &.right-btn {
                right: 24px;

                svg { transform: translate(2px, -2px); }
            }
            &[disabled] {
                background-color: $gray-lite;
            }
        }
    }
    &.-cards-slider {
        width: calc(100% - 170px);
        margin: 0 auto;

        .glide__slides {
            // Add padding so box shadows aren't cut off
            padding: 20px 0;
        }

        .controls {
            button {
                left: -60px;

                &.right-btn {
                    left: auto;
                    right: -60px;
                }
            }
        }
    }
    &.full-width {
        width: 100%;

        &::before, &::after {
            content: '';
            position: absolute;
            top: 0;
            width: 65px;
            height: 100%;
            z-index: 2;
        }
        &::before {
            left: 0;
            background: transparent linear-gradient(270deg, #FFFFFF00 0%, #FFFFFFA1 33%, #FFF 100%) 0% 0% no-repeat padding-box;
        }
        &::after {
            right: 0;
            background: transparent linear-gradient(90deg, #FFFFFF00 0%, #FFFFFFA1 33%, #FFF 100%) 0% 0% no-repeat padding-box;
        }
        .controls button {
            left: 24px;

            &.right-btn {
                left: auto;
                right: 24px;
            }
        }
    }
    .bullets-wrapper {
        display: flex;
        align-items: center;

        &.internal {
            position: absolute;
            bottom: 30px;
            left: 50%;
            transform: translateX(-50%);
        }

        &.external {
            justify-content: center;
            margin-top: 10px;

            .glide__bullets button {
                background: $pagingActive;
            }
            .pause-action {
                color: $primary;
                border-bottom: 1px solid transparent;

                &:hover, &:focus { border-bottom: 1px solid $gray-dark; }
            }
        }

        button {
            // reset default btn style
            border: none;
            outline: none;
            box-shadow: none;
            transition: all 350ms;
        }

        .glide__bullets button {
            margin: 0 7px;
            padding: 0;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            background: #fff;

            &:hover,
            &:focus {
                transform: scale(1.5);
            }

            &.glide__bullet--active {
                background: $pagingActive;
                transform: scale(2.4);
            }
        }
        .pause-action {
            background: none;
            color: #FFF;
            transition: all .3s ease-in-out;

            svg {
                @include svg-format(14px, 14px, currentColor);
                transform: translateY(-2px);
            }
            &:hover, &:focus {
                color: #000;
                transform: none;
                text-transform: underline;
                background: #FFF;

                svg {
                    color: $primary;
                }
            }
        }

    }


}

.sfPageEditor.zeContentMode {
    .st-carousel .controls button {
        display: none !important;
    }
}





@include media-breakpoint-down(lg) {
    .kdx-carousel {

        .controls {
            button {
                width: 36px;
                height: 36px;

                svg {
                    transform: translate(-2px, -2px);
                    @include svg-format(16px, 18px, currentColor);
                }
                &.right-btn {
                    svg { transform: translate(0, -2px); }
                }
            }
        }
        &.-cards-slider {
            width: calc(100% - 120px);
            padding: 0;

            .controls {
                button {
                    left: -50px;

                    &.right-btn {
                        left: auto;
                        right: -50px;
                    }
                }
            }
        }
        &.full-width {
            &::before { left: -30px; }
            &::after { right: -30px; }
            .controls button {
                left: 8px;

                &.right-btn {
                    left: auto;
                    right: 8px;
                }
            }
            &.-cards-slider {

                .controls button {
                    left: 8px;

                    &.right-btn {
                        left: auto;
                        right: 8px;
                    }
                }
            }
        }
    }
}
